import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const digiboards = {
    namespaced: true,
    state: {
        digiBoardsList: [],
        digiBoardLicenceContent: {},
        DigiBoardSettings: {},
        timeSlotsList: [],
        digiBoardTimeSlotsList: [],
        digiBoardTypesList: [],
        digiBoardAdvertisersList: [],
        digiBoardDetails: {},
        digiBoardTimeSlotPrices: {},
        createdDigiBoard: {},
        deviceRegistrationSuccessData: [],
        boardImages: [],
    },
    getters: {
        getDigiBoardsList (state) {
            return state.digiBoardsList;
        },
        getDigiBoardLicenceContent (state) {
            return state.digiBoardLicenceContent;
        },
        getDigiBoardSettings (state) {
            return state.DigiBoardSettings;
        },
        getTimeSlotsList (state) {
            return state.timeSlotsList;
        },
        getDigiBoardTimeSlotsList (state) {
            return state.digiBoardTimeSlotsList;
        },
        getDigiBoardTypesList (state) {
            return state.digiBoardTypesList;
        },
        getDigiBoardAdvertisersList (state) {
            return state.digiBoardAdvertisersList;
        },
        getDigiBoardDetails (state) {
            return state.digiBoardDetails;
        },
        getDigiBoardTmeSlotPrices (state) {
            return state.digiBoardTimeSlotPrices;
        },
        getCreatedDigiBoard (state) {
            return state.createdDigiBoard;
        },
        getDeviceRegistrationSuccessData (state) {
            return state.deviceRegistrationSuccessData;
        },
        getBoardImages (state) {
            return state.boardImages;
        },
    },
    mutations: {
        setDigiBoardsList (state, data) {
            state.digiBoardsList = data;
        },
        setDigiBoardLicenceContent (state, data) {
            state.digiBoardLicenceContent = data;
        },
        setDigiBoardSettingsDetails (state, data) {
            state.DigiBoardSettings = data;
        },
        setTimeSlotsList (state, data) {
            state.timeSlotsList = data;
        },
        setDigiBoardTimeSlotsList (state, data) {
            state.digiBoardTimeSlotsList = data;
        },
        setDigiBoardTypesList (state, data) {
            state.digiBoardTypesList = data;
        },
        setDigiBoardAdvertisersList (state, data) {
            state.digiBoardAdvertisersList = data;
        },
        setDigiBoardDetails (state, data) {
            state.digiBoardDetails = data;
        },
        setDigiBoardTimeSlotPrices (state, data) {
            state.digiBoardTimeSlotPrices = data;
        },
        setCreatedDigiBoard (state, data) {
            state.createdDigiBoard = data;
        },
        clearCreatedDigiBoards (state) {
            state.createdDigiBoard = {};
        },
        setDeviceRegistrationSuccessData (state, data) {
            state.deviceRegistrationSuccessData.push(data);
        },
        setBoardImages (state, data) {
            state.boardImages = data;
        },
    },
    actions: {
        async fetchDigiBoardsList ({ dispatch, commit }) {
            const url = '/digi-boards';
            try {
                const response = await axios.get(url);
                commit('setDigiBoardsList', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-boards list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchDigiBoardsUnderOrganization ({ dispatch, commit }, { params }) {
            const url = '/digi-boards';
            try {
                const response = await axios.get(url, { params: params });
                commit('setDigiBoardsList', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-boards under this organization.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createDigiBoard ({ dispatch, commit }, payload) {
            const url = '/digi-boards';
            try {
                const response = await axios.post(url, payload);
                commit('setCreatedDigiBoard', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating the digi-board.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createDigiBoardLicence ({ dispatch }, payload) {
            const url = '/digi-boards/licence';
            try {
                 await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your digi-board licence.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        clearCreatedDigiBoard ({ commit }) {
            commit('clearCreatedDigiBoards');
        },
        async fetchDigiBoardLicenceContent ({ dispatch, commit }, { params }) {
            const url = '/digi-boards/licence';
            try {
                const response = await axios.get(url, { params: params });
                const result = response.data[0] === undefined ? {} : response.data[0];
                commit('setDigiBoardLicenceContent', result);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-board Licence content.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async deleteLicence ({ dispatch }, licenceId) {
            const url = `/digi-boards/licence/cancel/${licenceId}`;
            try {
                await axios.post(url);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in deleting the Licence.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
         async fetchDigiBoardSettingsDetails ({ dispatch, commit, state }, payload) {
            const url = `${payload}/settings`;
            try {
                const details = await axios.get(url);
                commit('setDigiBoardSettingsDetails', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-board settings details.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
         async  createDigiBoardSettingsDetails ({ dispatch }, payload) {
            const url = `${payload.digiBoardId}/settings`;
            try {
                await axios.post(url, payload.settings);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating the digi-board settings.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async  updateDigiBoardSettingsDetails ({ dispatch }, payload) {
            const url = `${payload.digiBoardId}/settings/${payload.settingsId}`;
            try {
                await axios.put(url, payload.settings);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating the digi-board settings.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchTimeSlotsList ({ dispatch, commit }) {
            const url = '/time-slots';
            try {
                const response = await axios.get(url);
                commit('setTimeSlotsList', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the time slots list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async  createTimeSlot ({ dispatch }, payload) {
            const url = '/time-slots';
            try {
                await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating a new time slot.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchDigiBoardTimeSlotsList ({ dispatch, commit }, payload) {
            const url = `/digi-boards/${payload.digiBoard}/time-slots`;
            try {
                const response = await axios.get(url);
                commit('setDigiBoardTimeSlotsList', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-board time slot list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async  assignDigiBoardTimeSlot ({ dispatch }, payload) {
            const url = `/digi-boards/${payload.digiBoard}/time-slots`;
            try {
                await axios.post(url, payload.timeSlot);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in assigning this time slot to your selected digiboard.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async  updateDigiBoardTimeSlot ({ dispatch }, payload) {
            const url = `/digi-boards/time-slots/${payload.digiBoardTimeSlotId}`;
            try {
                await axios.put(url, payload.timeSlot);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating the digi-board time slot.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchDigiBoardTypesList ({ dispatch, commit }) {
            const url = '/digi-boards/specifications';
            try {
                const response = await axios.get(url);
                commit('setDigiBoardTypesList', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-board types list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createDigiBoardType ({ dispatch }, payload) {
            const url = '/digi-boards/specifications';
            try {
                await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating the digi-board type.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchDigiBoardAdvertisersList ({ dispatch, commit }, payload) {
            const url = `/digi-boards/${payload.digiBoard}/advertisers`;
            try {
                const response = await axios.get(url);
                commit('setDigiBoardAdvertisersList', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-board advertisers list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchDigiBoardDetails ({ dispatch, commit }, { params }) {
            const url = '/digi-boards';
            try {
                const response = await axios.get(url, { params: params });
                const result = response.data[0] === undefined ? {} : response.data[0];
                commit('setDigiBoardDetails', result);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-boards details.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async  updateDigiBoardDetails ({ dispatch }, payload) {
            const url = `/digi-boards/${payload.digiBoardId}`;
            try {
                await axios.put(url, payload.digiBoardDetails);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating digiboard details.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchDigiBoardTimeSlotPrices ({ dispatch, commit }, payload) {
            const url = `/digi-boards/time-slots/${payload.digiBoardTimeSlotId}/products`;
            try {
                const details = await axios.get(url);
                commit('setDigiBoardTimeSlotPrices', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-board time slot prices.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async  assignProductCategory ({ dispatch }, payload) {
            const url = `/digi-boards/time-slots/${payload.digiBoardTimeSlotId}/sync`;
            try {
                await axios.put(url, payload.productCategoryId);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating digiboard time slot product category.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async activateDevice ({ dispatch }, payload) {
            const url = `/digi-boards/${payload.digiBoardId}/register`;
            try {
              await axios.post(url, {
                registration_key: payload.licenceKey,
              });
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in activating device.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async cancelDigiBoardLicence ({ dispatch }, payload) {
            const url = `/digi-boards/${payload.digiBoardId}/re-register`;
            try {
              await axios.post(url, payload.comment);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in removing the connection from the device.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        addDeviceRegistrationSuccessData (context, event) {
            context.commit('setDeviceRegistrationSuccessData', event.digi_board_id);
        },
        async fetchBoardImages ({ dispatch, commit }, { params }) {
            const url = '/company-files';
            try {
                const images = await axios.get(url, { params: params });
                commit('setBoardImages', images.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the board images.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async uploadBoardImages ({ dispatch }, formData) {
            const url = '/company-files/upload';
            try {
                 await axios.post(url, formData);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in uploading your board images.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async deleteBoardImage ({ dispatch }, payload) {
            const url = `/company-files/${payload.uniqueFileName}`;
            try {
                await axios.delete(url);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in deleting this image.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
    },
};
